module.exports = __webpack_public_path__ + "img/new4.6f719eef.png";